import React, { useContext, useEffect, useState } from "react"
import { Button } from "react-bootstrap"
import { injectIntl } from "react-intl"
import moment from "moment/moment"

import AreYouSureModal from "../widgets/AreYouSureModal"
import { NewActionBody } from "./modals/ModalsParts"
import ActionEditModal from "./modals/ActionEditModal"
import { withOperatorActionConfig } from "../../config/OperatorActionConfigProvider"
import { AppSettingConfigContext } from "../../config/AppSettingsConfigProvider"
import { getLocaleFormattedUserString } from "../internationalization/LocaleFormatted"

function AlterCommentButtons({
  obj,
  reactor,
  editActionErr, // From OperatorActionConfigProvider
  deleteActionErr, // From OperatorActionConfigProvider
  createUpdateOrDeleteAction, // From OperatorActionConfigProvider
  intl, // From injectIntl
}) {
  const appConfig = useContext(AppSettingConfigContext)
  const [oaPermissions, setOaPermissions] = useState([])
  useEffect(() => {
    // Specific permissions for user to edit or delete operator actions
    if (appConfig?.config?.user?.permissions) {
      setOaPermissions(
        (appConfig.config.user.permissions || []).filter((permission) =>
          permission.includes("operatoraction"),
        ),
      )
    }
  }, [appConfig])

  const [actionObjToEdit, setActionObjToEdit] = useState({})
  const [showAreYouSureModal, setShowAreYouSureModal] = useState(false)
  const [showActionEditModal, setShowActionEditModal] = useState(false)

  useEffect(() => {
    if (deleteActionErr && actionObjToEdit?.id === obj?.id) {
      alert(
        `${intl.formatMessage({ id: "general.server.error" })}: ${intl.formatMessage({
          id: "general.delete",
        })}`,
      )
      setActionObjToEdit({})
    }
  }, [deleteActionErr])

  return (
    <>
      {showActionEditModal &&
        actionObjToEdit?.id === obj?.id &&
        oaPermissions.includes("change_operatoraction") && (
          <ActionEditModal
            showActionEditModal={showActionEditModal}
            onHide={() => {
              setShowActionEditModal(false)
              setActionObjToEdit({})
            }}
            actionObj={actionObjToEdit}
            reactor={reactor}
            editActionErr={editActionErr}
            createUpdateOrDeleteAction={createUpdateOrDeleteAction}
            intl={intl}
          />
        )}
      {showAreYouSureModal && oaPermissions.includes("delete_operatoraction") && (
        <AreYouSureModal
          show={showAreYouSureModal}
          onHide={() => setShowAreYouSureModal(false)}
          submitForm={() => {
            createUpdateOrDeleteAction(actionObjToEdit, "delete")
          }}
          cancelForm={() => setShowAreYouSureModal(false)}
          data={actionObjToEdit}
          modalBody={
            <NewActionBody
              data={{
                ...actionObjToEdit,
                source: reactor,
                actor: getLocaleFormattedUserString(actionObjToEdit.actor, intl),
                timestamp: moment(actionObjToEdit.timestamp).format("YYYY-MM-DDTHH:mm:ss"),
              }}
            />
          }
          deleteMode
        />
      )}

      <Button
        variant={"outline-primary"}
        size={"sm"}
        disabled={!oaPermissions.includes("change_operatoraction")}
        title={intl.formatMessage({ id: "general.edit" })}
        onClick={() => {
          setShowActionEditModal(true)
          setActionObjToEdit(obj)
        }}
      >
        <span className={"fa fa-pencil"} />
      </Button>

      <Button
        variant={"outline-primary"}
        size={"sm"}
        disabled={!oaPermissions.includes("delete_operatoraction")}
        title={intl.formatMessage({ id: "general.delete" })}
        onClick={() => {
          setShowAreYouSureModal(true)
          setActionObjToEdit(obj)
        }}
      >
        <span className={"fa fa-trash"} />
      </Button>
    </>
  )
}

export default injectIntl(withOperatorActionConfig(AlterCommentButtons))
